module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.2f55e0d4.ttf";